<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              სპეციალური ნივთის დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeAdd"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="productLoyaltyPrize.nameGe"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyaltyPrize.nameGe.$error,
                        valid:
                          $v.productLoyaltyPrize.nameGe.$dirty &&
                          !$v.productLoyaltyPrize.nameGe.$invalid,
                      }"
                    />
                    <label for="nameGeAdd">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnAdd"
                      class="form-control"
                      placeholder="English Name"
                      v-model="productLoyaltyPrize.nameEn"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyaltyPrize.nameEn.$error,
                        valid:
                          $v.productLoyaltyPrize.nameEn.$dirty &&
                          !$v.productLoyaltyPrize.nameEn.$invalid,
                      }"
                    />
                    <label for="nameEnAdd">English Name</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuAdd"
                      class="form-control"
                      placeholder="имя на русском"
                      v-model="productLoyaltyPrize.nameRu"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{
                        'error-border': $v.productLoyaltyPrize.nameRu.$error,
                        valid:
                          $v.productLoyaltyPrize.nameRu.$dirty &&
                          !$v.productLoyaltyPrize.nameRu.$invalid,
                      }"
                    />
                    <label for="nameRuAdd">имя на русском</label>
                  </div>
                </div>
                <div class="form-group form-check mt-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="isVatAdd"
                    v-model="productLoyaltyPrize.isVat"
                  />
                  <label class="form-check-label" for="isVatAdd">is Vat</label>
                </div>
                <div class="form-group form-check mt-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vatCanApplyAdd"
                    v-model="productLoyaltyPrize.vatCanApply"
                  />
                  <label class="form-check-label" for="vatCanApplyAdd"
                    >vat Can Apply</label
                  >
                </div>
                <label for="lotteryAdd">ბრენდი</label>
                <autocomplete
                  id="lotteryAdd"
                  :list="legalBrandArray"
                  optionField="nameGe"
                  @input="onAutocompleteInput"
                >
                  <div slot="list-item" slot-scope="{ item }">
                    {{ item.nameGe }}
                    <br />
                    {{ item.descriptionGe }}
                  </div>
                </autocomplete>
              </form>
              <form class="col-12 col-md-6">
                <!-- <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descGeAdd"
                      class="form-control"
                      placeholder="აღწერა ქართულად"
                      v-model="productLoyaltyPrize.descGe"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descGe.$error, valid: $v.productLoyaltyPrize.descGe.$dirty && !$v.productLoyaltyPrize.descGe.$invalid}"
                    >
                    <label for="descGeAdd">აღწერა ქართულად</label>
                  </div>
                </div> -->
                <div class="form-group">
                  <label for="descGeAdd">აღწერა ქართულად</label>
                  <textarea
                    class="form-control"
                    id="descGeAdd"
                    v-model="productLoyaltyPrize.descGe"
                    v-on:input="$v.productLoyaltyPrize.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyaltyPrize.descGe.$error,
                      valid:
                        $v.productLoyaltyPrize.descGe.$dirty &&
                        !$v.productLoyaltyPrize.descGe.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <!-- <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descEnAdd"
                      class="form-control"
                      placeholder="English Description"
                      v-model="productLoyaltyPrize.descEn"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descEn.$error, valid: $v.productLoyaltyPrize.descEn.$dirty && !$v.productLoyaltyPrize.descEn.$invalid}"
                    >
                    <label for="descEnAdd">English Description</label>
                  </div>
                </div> -->
                <div class="form-group">
                  <label for="descEnAdd">English Description</label>
                  <textarea
                    class="form-control"
                    id="descEnAdd"
                    v-model="productLoyaltyPrize.descEn"
                    v-on:input="$v.productLoyaltyPrize.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyaltyPrize.descEn.$error,
                      valid:
                        $v.productLoyaltyPrize.descEn.$dirty &&
                        !$v.productLoyaltyPrize.descEn.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <!-- <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descRuAdd"
                      class="form-control"
                      placeholder="описание на русском"
                      v-model="productLoyaltyPrize.descRu"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descRu.$error, valid: $v.productLoyaltyPrize.descRu.$dirty && !$v.productLoyaltyPrize.descRu.$invalid}"
                    >
                    <label for="descRuAdd">описание на русском</label>
                  </div>
                </div> -->
                <div class="form-group">
                  <label for="descRuAdd">описание на русском</label>
                  <textarea
                    class="form-control"
                    id="descRuAdd"
                    v-model="productLoyaltyPrize.descRu"
                    v-on:input="$v.productLoyaltyPrize.$touch"
                    v-bind:class="{
                      'error-border': $v.productLoyaltyPrize.descRu.$error,
                      valid:
                        $v.productLoyaltyPrize.descRu.$dirty &&
                        !$v.productLoyaltyPrize.descRu.$invalid,
                    }"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="prizeBuyPriceAdd"
                      class="form-control"
                      placeholder="პრიზის გასაყიდი ფასი"
                      v-model="productLoyaltyPrize.prizeBuyPrice"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{
                        'error-border':
                          $v.productLoyaltyPrize.prizeBuyPrice.$error,
                        valid:
                          $v.productLoyaltyPrize.prizeBuyPrice.$dirty &&
                          !$v.productLoyaltyPrize.prizeBuyPrice.$invalid,
                      }"
                    />
                    <label for="prizeBuyPriceAdd">პრიზის გასაყიდი ფასი</label>
                  </div>
                </div>
                <form method="post" class="mt-3">
                  <div class="custom-file">
                    <input
                      type="file"
                      ref="file"
                      multiple
                      @change="onFileSelected"
                      class="custom-file-input"
                      id="validatedCustomFile"
                    />
                    <label
                      class="custom-file-label"
                      for="validatedCustomFile"
                    ></label>
                  </div>
                </form>
                <img
                  class="img-thumbnail mt-3"
                  v-bind:src="imagePreview"
                  v-show="showPreview"
                />
              </form>
            </div>
          </div>
          <div class="modal-footer mt-5">
            <button
              type="button"
              class="btn btn-danger mt-5"
              data-dismiss="modal"
            >
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success mt-5"
              :disabled="
                !$v.productLoyaltyPrize.$dirty || $v.productLoyaltyPrize.$error
              "
              @click="$v.productLoyaltyPrize.$touch(), addProductLoyaltyPrize()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
            <th class="numeric">აღწერა ქართულად</th>
            <th class="numeric">Description Name</th>
            <th class="numeric">описание на русском</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueproductLoyaltyPrize in productLoyaltyPrizesArray"
            :key="valueproductLoyaltyPrize.id"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ valueproductLoyaltyPrize.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ valueproductLoyaltyPrize.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ valueproductLoyaltyPrize.nameRu }}
            </td>
            <td data-title="აღწერა ქართულად" class="numeric">
              {{ valueproductLoyaltyPrize.descGe }}
            </td>
            <td data-title="Description Name" class="numeric">
              {{ valueproductLoyaltyPrize.descEn }}
            </td>
            <td data-title=">описание на русском" class="numeric">
              {{ valueproductLoyaltyPrize.descRu }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <!-- <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLongEdit"
                  @click="editFillInputs(valueproductLoyaltyPrize)"
                ></i> -->
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueproductLoyaltyPrize.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5
              class="modal-title text-white"
              id="exampleModalLongTitle"
            >სპეციალური ნივთის რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeEdit"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="productLoyaltyPrize.nameGe"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.nameGe.$error, valid: $v.productLoyaltyPrize.nameGe.$dirty && !$v.productLoyaltyPrize.nameGe.$invalid}"
                    >
                    <label for="nameGeEdit">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnEdit"
                      class="form-control"
                      placeholder="English Name"
                      v-model="productLoyaltyPrize.nameEn"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.nameEn.$error, valid: $v.productLoyaltyPrize.nameEn.$dirty && !$v.productLoyaltyPrize.nameEn.$invalid}"
                    >
                    <label for="nameEnEdit">English Name</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuEdit"
                      class="form-control"
                      placeholder="имя на русском"
                      v-model="productLoyaltyPrize.nameRu"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.nameRu.$error, valid: $v.productLoyaltyPrize.nameRu.$dirty && !$v.productLoyaltyPrize.nameRu.$invalid}"
                    >
                    <label for="nameRuEdit">имя на русском</label>
                  </div>
                </div>
                <div class="form-group form-check mt-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="isVatEdit"
                    v-model="productLoyaltyPrize.isVat"
                  >
                  <label class="form-check-label" for="isVatEdit">is Vat</label>
                </div>
                <div class="form-group form-check mt-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="vatCanApplyEdit"
                    v-model="productLoyaltyPrize.vatCanApply"
                  >
                  <label class="form-check-label" for="vatCanApplyEdit">vat Can Apply</label>
                </div>
                <label for="lotteryEdit">ბრენდი</label>
                <autocomplete
                  id="lotteryEdit"
                  :list="legalBrandArray"
                  optionField="nameGe"
                  @input="onAutocompleteInput"
                >
                  <div slot="list-item" slot-scope="{item}">
                    {{item.nameGe}}
                    <br>
                    {{item.descriptionGe}}
                  </div>
                </autocomplete>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descGeEdit"
                      class="form-control"
                      placeholder="აღწერა ქართულად"
                      v-model="productLoyaltyPrize.descGe"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descGe.$error, valid: $v.productLoyaltyPrize.descGe.$dirty && !$v.productLoyaltyPrize.descGe.$invalid}"
                    >
                    <label for="descGeEdit">აღწერა ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descEnEdit"
                      class="form-control"
                      placeholder="English Description"
                      v-model="productLoyaltyPrize.descEn"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descEn.$error, valid: $v.productLoyaltyPrize.descEn.$dirty && !$v.productLoyaltyPrize.descEn.$invalid}"
                    >
                    <label for="descEnEdit">English Description</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="descRuEdit"
                      class="form-control"
                      placeholder="описание на русском"
                      v-model="productLoyaltyPrize.descRu"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.descRu.$error, valid: $v.productLoyaltyPrize.descRu.$dirty && !$v.productLoyaltyPrize.descRu.$invalid}"
                    >
                    <label for="descRuEdit">описание на русском</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="prizeBuyPriceEdit"
                      class="form-control"
                      placeholder="პრიზის გასაყიდი ფასი"
                      v-model="productLoyaltyPrize.prizeBuyPrice"
                      v-on:input="$v.productLoyaltyPrize.$touch"
                      v-bind:class="{'error-border': $v.productLoyaltyPrize.prizeBuyPrice.$error, valid: $v.productLoyaltyPrize.prizeBuyPrice.$dirty && !$v.productLoyaltyPrize.prizeBuyPrice.$invalid}"
                    >
                    <label for="prizeBuyPriceEdit">პრიზის გასაყიდი ფასი</label>
                  </div>
                </div>
                <form method="post" class="mt-3">
                  <div class="custom-file">
                    <input
                      type="file"
                      ref="fileEdit"
                      multiple
                      @change="onFileSelectedEdit"
                      class="custom-file-input"
                      id="validatedCustomFileEdit"
                    >
                    <label
                      class="custom-file-label"
                      for="validatedCustomFileEdit"
                    ></label>
                  </div>
                </form>
                <img
                  v-if="!editImg"
                  class="img-thumbnail mt-3"
                  :src="imageUrl()">
                <img
                  v-if="editImg"
                  class="img-thumbnail mt-3"
                  v-bind:src="imagePreview"
                  v-show="showPreview"
                >
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.productLoyaltyPrize.$dirty || $v.productLoyaltyPrize.$error"
              @click="$v.productLoyaltyPrize.$touch(), editProductLoyaltyPrize()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              სპეციალური ნივთის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteProductLoyaltyPrize()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required } from "vuelidate/lib/validators";
import { baseURL, imageURL } from "../../settings/settings.js";

export default {
  name: "legalBrandMenuGroup",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      productLoyaltyPrize: {
        id: "",
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        image: null,
        prizeBuyPrice: null,
        isVat: false,
        vatCanApply: false,
        legalBrandId: null,
      },
      legalBrand: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        logoSrc: null,
        lBCategoryId: null,
      },
      isActive: false,
      productLoyaltyPrizesArray: [],
      legalBrandArray: [],
      imagePreview: "",
      editImg: false,
      showPreview: false,
    };
  },
  validations: {
    productLoyaltyPrize: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      descGe: {
        required,
      },
      descEn: {
        required,
      },
      descRu: {
        required,
      },
      image: {
        required,
      },
      prizeBuyPrice: {
        required,
      },
      legalBrandId: {
        required,
      },
    },
  },
  async created() {
    let productLoyaltyPrizeResult = await this.$http.getProductLoyaltyPrize();
    this.productLoyaltyPrizesArray = productLoyaltyPrizeResult.data.res;

    let legalBrandResult = await this.$http.getLegalBrand();
    this.legalBrandArray = legalBrandResult.data.res;
  },
  methods: {
    async addProductLoyaltyPrize() {
      try {
        let data = new FormData();

        data.append("nameGe", this.productLoyaltyPrize.nameGe);
        data.append("nameEn", this.productLoyaltyPrize.nameEn);
        data.append("nameRu", this.productLoyaltyPrize.nameRu);
        data.append("descGe", this.productLoyaltyPrize.descGe);
        data.append("descEn", this.productLoyaltyPrize.descEn);
        data.append("descRu", this.productLoyaltyPrize.descRu);
        data.append("image", this.productLoyaltyPrize.image);
        data.append("prizeBuyPrice", this.productLoyaltyPrize.prizeBuyPrice);
        data.append("isVat", this.productLoyaltyPrize.isVat);
        data.append("vatCanApply", this.productLoyaltyPrize.vatCanApply);
        data.append("legalBrandId", this.productLoyaltyPrize.legalBrandId);

        let productLoyaltyPrizeAddResult =
          await this.$http.postProductLoyaltyPrize(data);

        if (productLoyaltyPrizeAddResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაციის მენიუ გრუპი წარმატებით დაემატა");
          let productLoyaltyPrizeResult =
            await this.$http.getProductLoyaltyPrize();
          this.productLoyaltyPrizesArray = productLoyaltyPrizeResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ორგანიზაციის მენიუ გრუპის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    // async editProductLoyaltyPrize () {
    //   try {
    //     let data = new FormData()

    //     data.append('id', this.productLoyaltyPrize.id)
    //     data.append('nameGe', this.productLoyaltyPrize.nameGe)
    //     data.append('nameEn', this.productLoyaltyPrize.nameEn)
    //     data.append('nameRu', this.productLoyaltyPrize.nameRu)
    //     data.append('descGe', this.productLoyaltyPrize.descGe)
    //     data.append('descEn', this.productLoyaltyPrize.descEn)
    //     data.append('descRu', this.productLoyaltyPrize.descRu)
    //     data.append('image', this.productLoyaltyPrize.image)
    //     data.append('prizeBuyPrice', this.productLoyaltyPrize.prizeBuyPrice)
    //     data.append('isVat', this.productLoyaltyPrize.isVat)
    //     data.append('vatCanApply', this.productLoyaltyPrize.vatCanApply)
    //     data.append('legalBrandId', this.productLoyaltyPrize.legalBrandId)
    //     let productLoyaltyPrizeEditResult = await this.$http.post(
    //       baseURL + 'files/1.0/lottery/edit-lottery-prize',
    //       data
    //     )
    //     if (productLoyaltyPrizeEditResult.data.resultCode === '200') {
    //       bus.$emit('success', 'პროდუქტის ლოიალობის პრიზი წარმატებით დარედაქტირდა')
    //       let productLoyaltyPrizeResult = await this.$http.getProductLoyaltyPrize()
    //       this.productLoyaltyPrizesArray = productLoyaltyPrizeResult.data.res
    //       this.editImg = false
    //     } else {
    //       bus.$emit('warning', 'პროდუქტის ლოიალობის პრიზის რედაქტირების დროს მოხდა შეცდომა')
    //     }
    //   } catch (error) {
    //     bus.$emit('error', error)
    //   }
    // },
    async deleteProductLoyaltyPrize() {
      try {
        let productLoyaltyPrizeDeleteResult = await this.$http.post(
          baseURL + "api/lottery/1.0/delete-lottery-prize",
          { id: this.productLoyaltyPrize.id }
        );
        if (productLoyaltyPrizeDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ლოიალობის პრიზი წარმატებით წაიშალა");
          let productLoyaltyPrizeResult =
            await this.$http.getProductLoyaltyPrize();
          this.productLoyaltyPrizesArray = productLoyaltyPrizeResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ლოიალობის პრიზის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    // async editFillInputs (row) {
    //   let productLoyaltyPrizeResult = await this.$http.post(
    //     baseURL + 'api/lottery/1.0/get-prize-by-id',
    //     { id: row.id })
    //   this.productLoyaltyPrize = productLoyaltyPrizeResult.data.res
    // },
    getDeleteId(id) {
      this.productLoyaltyPrize.id = id;
    },
    onFileSelected() {
      this.productLoyaltyPrize.image = this.$refs.file.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.productLoyaltyPrize.image) {
        if (/\.(jpe?g|png|gif)$/i.test(this.productLoyaltyPrize.image.name)) {
          reader.readAsDataURL(this.productLoyaltyPrize.image);
        }
      }
    },
    onFileSelectedEdit() {
      this.productLoyaltyPrize.image = this.$refs.fileEdit.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.productLoyaltyPrize.image) {
        if (/\.(jpe?g|png|gif)$/i.test(this.productLoyaltyPrize.image.name)) {
          reader.readAsDataURL(this.productLoyaltyPrize.image);
        }
      }
      this.editImg = true;
    },
    imageUrl() {
      if (this.productLoyaltyPrize.image) {
        return "http://api.wisher.ge:8080/" + this.productLoyaltyPrize.image;
      }
    },
    onAutocompleteInput(object) {
      this.productLoyaltyPrize.legalBrandId = object.id;
    },
    modalPrepare() {
      this.isActive = true;
    },
    clearData() {
      this.productLoyaltyPrize.id = null;
      this.productLoyaltyPrize.nameGe = "";
      this.productLoyaltyPrize.nameEn = "";
      this.productLoyaltyPrize.nameRu = "";
      this.productLoyaltyPrize.descGe = "";
      this.productLoyaltyPrize.descEn = "";
      this.productLoyaltyPrize.descRu = "";
      this.productLoyaltyPrize.image = null;
      this.productLoyaltyPrize.prizeBuyPrice = null;
      this.productLoyaltyPrize.isVat = false;
      this.productLoyaltyPrize.vatCanApply = false;
      this.productLoyaltyPrize.legalBrand = [];
      this.legalBrand.id = null;
      this.legalBrand.nameGe = "";
      this.legalBrand.nameEn = "";
      this.legalBrand.nameRu = "";
      this.legalBrand.descGe = "";
      this.legalBrand.descEn = "";
      this.legalBrand.descRu = "";
      this.legalBrand.logoSrc = null;
      this.legalBrand.lBCategoryId = null;
      this.legalBrandAutocompleteArray = [];
      this.selectedLegalBrandArray = [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }

// .modal-nav-button {
//   margin-left: 15px;
// }

// .modal-nav {
//   color: #52af8e;
// }

// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// .pointer {
//   cursor: pointer;
// }

// .modal-card {
//   background-color: #eef7f4;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/ProductLoyaltyPrize.vue